import { render, staticRenderFns } from "./Unsuscribe.vue?vue&type=template&id=1964fa4e&"
import script from "./Unsuscribe.vue?vue&type=script&lang=js&"
export * from "./Unsuscribe.vue?vue&type=script&lang=js&"
import style0 from "./Unsuscribe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports